export const frontErrorText = {
  errorAlt: 'Error',
  errorMessage: 'No podemos mostrarte la información en este momento',
  errorTitle: 'No podemos mostrarte la información en este momento',
  errorSubtitle: 'Por favor, inténtalo de nuevo más tarde.',
  internetError:
    'Pronto podrás ver aquí toda la información de tu conexión a internet',
  internetAlt: 'Internet',
  tvError: 'Pronto podrás ver aquí toda la información de tu TV',
  tvAlt: 'TV',
};

export const loginText = {
  loginButton: 'Entrar',
  loginDocument: 'NIF/CIF/NIE/Pasaporte',
  loginPassword: 'Contraseña',
  loginSubtitle:
    'Para continuar es necesario que te identifiques.',
  loginTitle: 'Accede',
};

export const navigationText = {
  back: 'Atrás',
};

export const salute = {
  evening: 'Buenas tardes',
  morning: 'Buenos días',
  night: 'Buenas noches',
};

export const searcherText = {
  placeholder: 'Escribe aquí tu pregunta',
};

export const serverErrorText = {
  errorAlt1: 'error',
  errorTitle1:
    'Estamos trabajando para ofrecerte la información que has solicitado',
  errorAlt2: 'error',
  errorMessage2: 'Por favor, inténtalo de nuevo más tarde',
  errorTitle2: 'No podemos mostrarte la información en este momento',
  errorLabelButton3: 'Cerrar sesión',
};

export const betaAdviceTexts = {
  contentTitle: 'Seguimos mejorando "Wajujogido"',
  contentSubtitle:
    'Ya tienes disponible información sobre tu conexión a Internet',
};

export const maintenanceStopperTexts = {
  errorTitle: 'Tareas de mantenimiento',
  errorSubtitle:
    'Estamos haciendo tareas de matenimiento, volvemos lo antes posible',
  errorAlt: 'Mantenimiento',
  errorLabelButton: 'Ayúdanos a mejorar',
};

export const buttonLabel = {
  accept: 'Aceptar',
  cancel: 'Cancelar',
  continue: 'Continuar',
  finish: 'Finalizar',
};
